import { api } from '@/core/api/';

export const getApplicationsList = async () => {
    try {
        const { data } = await api.get("/api/applications/list")
        return data;
    } catch (error) {
        return [];
    }
}

//ECG:filters contiene {name:'nombredefiltro', value:'valordelfiltro'}
export const getApplicationSearchResults = (filters) => api.get('/api/applications/search', {
    params: filters
})

export const addNewApplication = (newApp) => {
    try {
        return api.post("/api/applications", newApp);
    } catch (error) {
        return error;
    }
}

export const getApplication = async (applicationId) => {
    try {
        const { data } = await api.get("/api/applications/" + applicationId);
        return data;
    } catch (error) {
        return error;
    }
}

export const updateApplication = async (appData) => {
    try {
        return api.put("/api/applications", appData);
    } catch (error) {
        return error;
    }
}

